function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.487 9.498a9.944 9.944 0 00-3.935-3.705 4.782 4.782 0 003.935 3.705zm.705 1.42a6.142 6.142 0 01-6.1-5.744 9.947 9.947 0 00-6.946.249 9.95 9.95 0 00-3.23 16.233 9.955 9.955 0 0014.076 0 9.95 9.95 0 002.2-10.737zm-6.337-.078a1.253 1.253 0 10-.96 2.316 1.253 1.253 0 00.96-2.316zm-4.437.274a1.253 1.253 0 00-.883-.369H7.52a1.253 1.253 0 00.015 2.507 1.253 1.253 0 00.883-2.138zm-.369 8.103a4.977 4.977 0 006.883-4.6H4.978a4.972 4.972 0 003.071 4.6z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.846 1.4a4.777 4.777 0 116.756 6.755 4.777 4.777 0 01-6.756-6.756zm6.361 2.307a1 1 0 00-1.414-1.414L18.5 4.586l-.793-.793a1 1 0 10-1.414 1.414L18.5 7.414l3.707-3.707z",
  fill: "#fff"
})));